import { Status } from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useQuery } from 'react-query'

const statusKeys = {
  elmo: 'elmoStatus' as const
}

export const useElmoStatus = () => {
  const fetchElmoStatus = async () => {
    const res = await medicareApiClient.statusApi.elmoStatus()

    return res.data
  }

  return useQuery<Status | undefined>(
    statusKeys.elmo,
    fetchElmoStatus
  )
}
